import { Injectable } from '@angular/core';

import { ProductSimpleSpec, TmsWebBaseEditService } from 'tms-web-shared';

@Injectable({
  providedIn: 'root',
})
export class ProductSimpleSpecService extends TmsWebBaseEditService<ProductSimpleSpec, ProductSimpleSpec> {
  constructor() {
    super('SimpleProductSpec', $localize`Simple Spec`);
  }
}
